/**
 * The money a product form edits, formatted one way wherever it is typed — the
 * product's own boxes and each variant's price editor read from here, so the two
 * cannot drift into rounding the same figure differently.
 */

/** A price or an incentive — anything the API keeps to the cent. */
export const centsFormat: Intl.NumberFormatOptions = {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
}

/**
 * A unit cost, which the API keeps to four places: a 3.5¢ ingredient rounded to
 * 4¢ is off by an eighth, and the margin it feeds is off with it.
 *
 * The field steps by the same ten-thousandth. React Aria snaps a typed value to
 * the step, so a cent step would quietly turn $0.0035 into $0.00 — a stepper that
 * barely moves is the lesser cost, and a cost is typed far more than stepped.
 */
export const costFormat: Intl.NumberFormatOptions = {
  ...centsFormat,
  maximumFractionDigits: 4,
}

export const COST_STEP = 0.0001

export const COST_HELP =
  'What one unit costs you. Leave blank if unknown — margin is only shown for items with a cost.'

export const INCENTIVE_HELP = 'Paid to the cashier per unit sold.'
